import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApi } from '../hooks/useApi';
import { motion } from 'framer-motion';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const api = useApi();

  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await api.post('/auth/login', formData);
      login(response.data.user, response.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Authentication declined.');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "w-full bg-transparent border-b border-white/20 text-white px-0 py-4 text-sm font-light transition-colors duration-300 focus:outline-none focus:border-gold placeholder:text-white/20 tracking-wide";

  return (
    <div className="min-h-screen bg-deepDark flex items-center justify-center px-4 relative overflow-hidden">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none"></div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="text-center mb-12">
          <h1 className="text-4xl font-serif text-white tracking-wider mb-4">LuxeJewels</h1>
          <p className="text-[10px] tracking-widest uppercase text-textMuted">Client Authentication</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-surfaceDark border border-white/5 p-10 shadow-2xl space-y-8">
          <div>
            <input type="email" name="email" placeholder="Registered Email" value={formData.email} onChange={handleChange} className={inputClass} required />
          </div>
          <div>
            <input type="password" name="password" placeholder="Passcode" value={formData.password} onChange={handleChange} className={inputClass} required />
          </div>

          {error && (
            <div className="text-red-500/80 text-[10px] tracking-widest uppercase border border-red-500/20 bg-red-500/5 p-3 text-center">
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="w-full bg-gold text-deepDark font-bold py-4 text-xs tracking-widest uppercase hover:bg-white transition-colors duration-300 disabled:opacity-50">
            {loading ? 'Authenticating...' : 'Access Collection'}
          </button>
        </form>

        <p className="text-center mt-12 text-xs font-light tracking-wide text-textMuted">
          Not a client? <Link to="/register" className="text-gold uppercase tracking-widest text-[10px] font-bold hover:text-white transition-colors ml-2 border-b border-gold/30 hover:border-white">Inquire Here</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default LoginPage;
